import { concat } from '@ember/helper';
import { utc } from 'moment-timezone';
import BvInline from 'volta/components/bv-inline';
import BvTag from 'volta/components/bv-tag';
import BvText from 'volta/components/bv-text';
import tElse from 'volta/helpers/t-else';
import momentFromNow from 'ember-moment/helpers/moment-from-now';

import type { TOC } from '@ember/component/template-only';
import type { IHistoryRecord } from 'volta/routes/base';

interface BvAppSearchEntryHistorySignature {
  Args: {
    history: IHistoryRecord;
  };
}

const BvAppSearchEntryHistoryComponent: TOC<BvAppSearchEntryHistorySignature> = <template>
  <BvInline @align='space-between' @blockAlign='center'>
    <div class='u-flex-1'>
      <BvTag @size='sm'>
        {{if
          @history.tab
          (concat (tElse @history.title) ' - ' (tElse @history.tab))
          (tElse @history.title)
        }}
      </BvTag>
    </div>
    <BvText
      @color='subdued'
      @text={{momentFromNow (utc @history.lastVisitedAt)}}
      @variant='body-sm'
      datetime='{{@history.lastVisitedAt}}'
    />
  </BvInline>
</template>;

export default BvAppSearchEntryHistoryComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::History': typeof BvAppSearchEntryHistoryComponent;
    'bv-app-search/entry/history': typeof BvAppSearchEntryHistoryComponent;
  }
}
